var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7308 15.7528C23.43 15.7528 24 15.1828 24 14.4836C24 13.7844 23.43 13.2144 22.7308 13.2144H4.26923C3.57001 13.2144 3 13.7844 3 14.4836C3 15.1828 3.57001 15.7528 4.26923 15.7528H22.7308Z",
    fill: "#545454",
    stroke: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelCollapseIcon);
export default __webpack_public_path__ + "static/media/panelCollapseIcon.2a8b1285268306db24d729e832e0f676.svg";
export { ForwardRef as ReactComponent };